import vueRouter from 'vue-router'

import Vue from 'vue'


Vue.use(vueRouter)



let siteRoutes = [];

function importAll(r) {
	r.keys().forEach((key) => {
		let path = (key.split('.'))[1];
		path.indexOf('Home') > -1 ? path = '/' : '';
		siteRoutes.push({
			path: path,
			name: path.substring(1),
			component: () => r(key)
		})
	});
}



importAll(require.context('../views/', true, /\.vue$/, 'lazy')); // 第二个参数指是否使用子目录 第四个参数是指是否异步 lazy/sync　

siteRoutes.push({
	path: '',
	redirect: '/index'
});


const routes = [
	...siteRoutes,
]

const router = new vueRouter({
	mode: 'history',
	routes
})


router.beforeEach((to, from, next) => {
	if (to.matched.length === 0) {
		next('/index')
	} else {
		next()
	}
})


export default router
